(() => {
 const data = document.getElementById('nov-navigation-data');
 if (!data || window.NOVJourney) return;
 const config = JSON.parse(data.textContent);
 const routes = config.routes;
 const draft = config.previewTheme;
 const business = () => document.body.classList.contains('nov-business');
 const deferred = new Set(['nov-catering-events','nov-catering-application','nov-hospitality-corporate','nov-hospitality-application']);
 const oldViews = {'tcp-business':'nov-business-supply','tcp-supply':'nov-business-supply','tcp-trade':'nov-business-supply','tcp-wholesale':'nov-wholesale-supply','tcp-school':'nov-schools-tuckshops','tcp-range':'nov-wholesale-catalogue'};
 const aliases = {'/pages/wholesale-customer-login':'nov-business-supply','/collections/public-shop':'nov-public-shop','/collections/family-favourites':'nov-family-favourites','/collections/schools-tuckshops':'nov-school-catalogue'};
 Object.entries(routes).forEach(([view,path]) => {
  aliases['/pages/'+view]=view;
  const pathname=path.split('#')[0];
  if (pathname!=='/' && !pathname.startsWith('/policies/') && !aliases[pathname]) aliases[pathname]=view;
 });
 const route = (view,extra={},hash='') => {
  const original=view;
  if (view==='nov-freezer-planner') view='nov-family-favourites';
  if (view==='nov-business-login' || deferred.has(view)) view='nov-business-supply';
  if (!routes[view]) view='nov-business-supply';
  const isBusiness=/^nov-(business|wholesale|school|schools)/.test(view);
  const native=view==='nov-public-contact'||view==='nov-public-delivery';
  const url=new URL(draft&&!native?(isBusiness?'/pages/wholesale-customer-login':'/pages/contact'):routes[view],location.origin);
  if(draft){if(!native)url.searchParams.set('view',view);url.searchParams.set('preview_theme_id',String(draft));}
  Object.entries(extra).forEach(([key,value])=>{if(value!==null&&value!==undefined&&value!==''&&key!=='view'&&key!=='preview_theme_id')url.searchParams.set(key,String(value));});
  if(hash)url.hash=hash;
  else if(original==='nov-freezer-planner')url.hash='nov-family-planner';
  else if(original==='nov-business-login')url.hash='profiles';
  return url.pathname+url.search+url.hash;
 };
 const normalize = (raw,label='',authReturn=false) => {
  if(!raw||raw.startsWith('#'))return raw;
  let url;
  try{url=new URL(raw,location.href);}catch(_){return raw;}
  if(url.origin!==location.origin)return raw;
  if(url.pathname==='/customer_authentication/login'){
   const target=url.searchParams.get('return_to');
   if(target&&!authReturn){const next=new URL(target,location.origin);if(next.origin===location.origin)url.searchParams.set('return_to',normalize(target.replace(/&amp;/g,'&'),'',true));}
   return url.pathname+url.search+url.hash;
  }
  const currentView=url.searchParams.get('view');
  if(currentView&&!routes[currentView]&&!oldViews[currentView]&&currentView!=='tcp-apply'&&currentView!=='home-family')return raw;
  let view=routes[currentView]?currentView:oldViews[currentView];
  if(!view&&currentView==='tcp-apply'&&url.pathname==='/pages/contact'){
   view=url.searchParams.get('business')==='school'?'nov-school-application':url.searchParams.get('business')==='wholesale'?'nov-wholesale-application':'nov-business-supply';
  }
  if(!view)view=aliases[url.pathname];
  if(!business()&&/business\s*log\s*in/i.test(label))view='nov-business-login';
  if(!business()&&url.pathname==='/')view='nov-home';
  if(!business()&&url.pathname==='/collections/all'&&(!currentView||currentView==='home-family'))view=currentView==='home-family'?'nov-family-favourites':'nov-public-shop';
  if(business()&&view==='nov-public-portion-calculator')view='nov-wholesale-calculator';
  if(view){const extra=Object.fromEntries(url.searchParams.entries());delete extra.view;delete extra.preview_theme_id;delete extra.business;return route(view,extra,url.hash);}
  if(draft&&/^\/(pages|policies|products|collections|cart|search)(\/|$)/.test(url.pathname)){url.searchParams.set('preview_theme_id',String(draft));return url.pathname+url.search+url.hash;}
  return raw;
 };
 const rewrite=link=>{
  const raw=link.getAttribute('href');
  if(!raw)return;
  let url;try{url=new URL(raw,location.href);}catch(_){return;}
  if(url.origin===location.origin&&(deferred.has(url.searchParams.get('view'))||['/pages/catering-hub','/pages/hospitality-corporate','/pages/nov-catering-events','/pages/nov-hospitality-corporate'].includes(url.pathname))){link.hidden=true;const item=link.closest('li');if(item)item.hidden=true;return;}
  const next=normalize(raw,link.textContent.trim());
  if(next!==raw)link.setAttribute('href',next);
 };
 const refresh=()=>document.querySelectorAll('a[href]').forEach(rewrite);
 window.NOVJourney={route,normalize,refresh};
 refresh();
 document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(link)rewrite(link);},true);
})();
